exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editer[data-v-17f95546]  .mce-tinymce{-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
